import styled from 'styled-components';

export const FilterButton = styled.div`
    button {
        border: 1.5px dashed #d1d5db;
        border-radius: 9999px;
        background-image: none;
    }

    button:hover {
        border-color: #9ca3af;
    }
`;
